import PropTypes from 'prop-types'
import React from 'react'
import { Element } from 'react-scroll'

const BuyDataForm = props => (
  <Element
    className={props.active ? 'process__box active' : 'process__box'}
    id={props.id}
    name={props.name || ''}
  >
    <ul
      className={
        (props.active ? 'data-form x-small active' : 'data-form x-small') +
        (props.className ? ` ${props.className}` : '')
      }
      style={props.active ? { display: 'block' } : {}}
    >
      <li className={`wide${props.liWideClass ? ` ${props.liWideClass}` : ''}`}>
        <h5
          className={
            (props.active
              ? 'section-title --reduced secondary active'
              : 'section-title --reduced') +
            (props.titleClass ? ` ${props.titleClass}` : '')
          }
        >
          {props.title}
        </h5>
        {props.panel}
      </li>
      {props.children}
    </ul>
  </Element>
)

BuyDataForm.defaultProps = {
  panel: null,
}

BuyDataForm.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string,
  id: PropTypes.string,
  icon: PropTypes.string.isRequired,
  panel: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.element.isRequired,
  ]),
}

export default BuyDataForm
